import React, { createContext, useContext, useState, ReactNode } from 'react';
import { CartItem, AdSpace } from '../types';

interface CartContextType {
  items: CartItem[]; addToCart: (space: AdSpace) => void;
  removeFromCart: (id: string) => void; updateItem: (id: string, updates: Partial<CartItem>) => void;
  clearCart: () => void; total: number; itemCount: number;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

export const CartProvider = ({ children }: { children: ReactNode }) => {
  const [items, setItems] = useState<CartItem[]>([]);

  const addToCart = (space: AdSpace) => {
    if (!items.find(i => i.space.id === space.id))
      setItems(p => [...p, { space, needsPrinting:false, needsInstallation:false, needsRemoval:false, printingCharge:0, installationCharge:0 }]);
  };

  const removeFromCart = (id: string) => setItems(p => p.filter(i => i.space.id !== id));
  const updateItem = (id: string, updates: Partial<CartItem>) =>
    setItems(p => p.map(i => i.space.id === id ? { ...i, ...updates } : i));
  const clearCart = () => setItems([]);

  const total = items.reduce((s, i) => {
    const base = i.space.rentAmount + i.space.commission + i.printingCharge + i.installationCharge;
    return s + base + (base * i.space.gst / 100);
  }, 0);

  return (
    <CartContext.Provider value={{ items, addToCart, removeFromCart, updateItem, clearCart, total, itemCount: items.length }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used within CartProvider');
  return ctx;
};
